module.exports = __webpack_public_path__ + "img/block2-2.ce898d57.svg";